import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MovementRecord = Record<string, unknown> & { id?: number };

interface MovementListState {
  list: MovementRecord[];
  pageNum: number;
  totalPages: number;
}

interface MovementState {
  transfer: MovementListState;
  entree: MovementListState;
  sortie: MovementListState;
  vente: MovementListState;
}

const initialList: MovementListState = { list: [], pageNum: 0, totalPages: 0 };

const initialState: MovementState = {
  transfer: { ...initialList },
  entree: { ...initialList },
  sortie: { ...initialList },
  vente: { ...initialList },
};

const movementSlice = createSlice({
  name: 'movement',
  initialState,
  reducers: {
    setTransfer(state, action: PayloadAction<{ data: MovementRecord[]; pageNum?: number; totalPages?: number }>) {
      state.transfer.list = action.payload.data ?? [];
      state.transfer.pageNum = typeof action.payload.pageNum === 'number' ? action.payload.pageNum : 0;
      state.transfer.totalPages = typeof action.payload.totalPages === 'number' ? action.payload.totalPages : 0;
    },
    setEntree(state, action: PayloadAction<{ data: MovementRecord[]; pageNum?: number; totalPages?: number }>) {
      state.entree.list = action.payload.data ?? [];
      state.entree.pageNum = typeof action.payload.pageNum === 'number' ? action.payload.pageNum : 0;
      state.entree.totalPages = typeof action.payload.totalPages === 'number' ? action.payload.totalPages : 0;
    },
    setSortie(state, action: PayloadAction<{ data: MovementRecord[]; pageNum?: number; totalPages?: number }>) {
      state.sortie.list = action.payload.data ?? [];
      state.sortie.pageNum = typeof action.payload.pageNum === 'number' ? action.payload.pageNum : 0;
      state.sortie.totalPages = typeof action.payload.totalPages === 'number' ? action.payload.totalPages : 0;
    },
    setVente(state, action: PayloadAction<{ data: MovementRecord[]; pageNum?: number; totalPages?: number }>) {
      state.vente.list = action.payload.data ?? [];
      state.vente.pageNum = typeof action.payload.pageNum === 'number' ? action.payload.pageNum : 0;
      state.vente.totalPages = typeof action.payload.totalPages === 'number' ? action.payload.totalPages : 0;
    },
  },
});

export const { setTransfer, setEntree, setSortie, setVente } = movementSlice.actions;
export default movementSlice.reducer;
